<template>
	<div class="warehouse-promo">
		<div class="empty-guide" v-if="ready && !warehouseId">
			<div class="empty-title">请先开通云仓</div>
			<el-button type="primary" @click="goIndex">返回云仓首页</el-button>
		</div>
		<div class="tablebox" v-if="ready && warehouseId">
			<div class="edit-card">
				<div class="edit-title">{{ editForm.id ? '编辑规则' : '新建规则' }}<span class="count-text">（{{ count }} / {{ maxCount }} 条，结算时自动取对顾客最优的一条，只减实收）</span></div>
				<el-form class="edit-form" label-width="80px" size="small">
					<el-form-item label="类型">
						<el-radio-group v-model="editForm.type">
							<el-radio :label="1">满件数折</el-radio>
							<el-radio :label="2">满金额折</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="满件数">
						<el-input v-model="editForm.threshold" placeholder="正整数件数，选满件数折时必填"></el-input>
					</el-form-item>
					<el-form-item label="满金额">
						<el-input v-model="editForm.threshold_yuan" placeholder="如 200，选满金额折时必填">
							<template slot="append">元</template>
						</el-input>
					</el-form-item>
					<el-form-item label="折扣">
						<el-input v-model="editForm.discount" placeholder="0~10 开区间，如 9.3">
							<template slot="append">折</template>
						</el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" :loading="saving" :disabled="!editForm.id && count >= maxCount" @click="onSave">{{ editForm.id ? '保存修改' : '新建规则' }}</el-button>
						<el-button @click="resetEdit">清空</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="tablediv">
				<el-table :data="list" style="width: 100%" border height="100%">
					<el-table-column prop="type_str" label="类型" align="center" width="110px"></el-table-column>
					<el-table-column prop="threshold_display" label="门槛" align="center" min-width="120px"></el-table-column>
					<el-table-column label="折扣" align="center" width="90px">
						<template slot-scope="scope">{{ scope.row.discount_display }}折</template>
					</el-table-column>
					<el-table-column label="状态" align="center" width="90px">
						<template slot-scope="scope">
							<span :class="'state-' + scope.row.state">{{ scope.row.state_str }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="update_time_str" label="更新时间" align="center" width="160px"></el-table-column>
					<el-table-column label="操作" fixed="right" align="center" width="160px">
						<template slot-scope="scope">
							<div class="operation_i">
								<span @click="openEdit(scope.row)">编辑</span>
								<span v-if="scope.row.state == 1" @click="onToggle(scope.row, 0)">停用</span>
								<span v-else @click="onToggle(scope.row, 1)">启用</span>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
	</div>
</template>

<script>
	import { yuanToFen, apiMsg } from './money.js'

	export default {
		name: 'WarehousePromotion',
		data() {
			return {
				ready: false,
				warehouseId: '',
				list: [],
				count: 0,
				maxCount: 5,
				saving: false,
				editForm: {
					id: '',
					type: 1,
					threshold: '',
					threshold_yuan: '',
					discount: ''
				}
			}
		},
		mounted() {
			this.loadWarehouse()
		},
		methods: {
			goIndex() {
				this.$router.push('/buyer/warehouse/index')
			},
			loadWarehouse() {
				this.$axios.get('api/cloud_warehouse/info').then(res => {
					this.ready = true
					if (res.data.code === 0) {
						var info = res.data.data || {}
						this.warehouseId = info.id || ''
						if (this.warehouseId) {
							this.onlist()
						}
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					this.ready = true
					console.log(err)
				})
			},
			onlist() {
				this.$axios.get('api/cloud_warehouse/promotion_list', {
					params: { warehouse_id: this.warehouseId }
				}).then(res => {
					if (res.data.code === 0) {
						var data = res.data.data || {}
						this.list = data.list || []
						this.count = data.count || 0
						this.maxCount = data.max_count || 5
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					console.log(err)
				})
			},
			openEdit(row) {
				this.editForm = {
					id: row.id,
					type: Number(row.type || 1),
					threshold: Number(row.type) === 1 ? String(row.threshold || '') : '',
					threshold_yuan: Number(row.type) === 2 ? (Number(row.threshold || 0) / 100).toFixed(2) : '',
					discount: row.discount_display || ''
				}
			},
			resetEdit() {
				this.editForm = {
					id: '',
					type: 1,
					threshold: '',
					threshold_yuan: '',
					discount: ''
				}
			},
			onSave() {
				var type = Number(this.editForm.type || 1)
				var discount = parseFloat(this.editForm.discount)
				if (isNaN(discount) || discount <= 0 || discount >= 10) {
					this.$message.warning('折扣范围为0-10（如9表示9折）')
					return
				}
				var threshold = 0
				if (type === 1) {
					threshold = Number(this.editForm.threshold)
					if (!threshold || threshold !== Math.floor(threshold)) {
						this.$message.warning('满件数须为整数件')
						return
					}
				} else {
					if (this.editForm.threshold_yuan === '') {
						this.$message.warning('请填写满金额')
						return
					}
					threshold = yuanToFen(this.editForm.threshold_yuan)
					if (isNaN(threshold) || threshold <= 0) {
						this.$message.warning('请填写满金额')
						return
					}
				}
				var payload = {
					warehouse_id: this.warehouseId,
					type: type,
					threshold: threshold,
					discount: discount
				}
				if (this.editForm.id) {
					payload.id = this.editForm.id
				}
				this.saving = true
				this.$axios.post('api/cloud_warehouse/promotion_save', payload).then(res => {
					this.saving = false
					if (res.data.code === 0) {
						this.$message.success(this.editForm.id ? '规则已更新' : '规则已新建')
						this.resetEdit()
						this.onlist()
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					this.saving = false
					console.log(err)
				})
			},
			onToggle(row, state) {
				this.$axios.post('api/cloud_warehouse/promotion_toggle', {
					warehouse_id: this.warehouseId,
					id: row.id,
					state: state
				}).then(res => {
					if (res.data.code === 0) {
						this.$message.success(state == 1 ? '已启用' : '已停用')
						this.onlist()
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					console.log(err)
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.warehouse-promo {
		height: 100%;
	}

	.tablebox {
		height: 100%;
	}

	.edit-card {
		background: #fff;
		border: 1px solid #EBEEF5;
		padding: 16px 16px 0;
		margin-bottom: 12px;
	}

	.edit-title {
		font-weight: 600;
		margin-bottom: 8px;
	}

	.edit-form {
		max-width: 520px;
	}

	.tablediv {
		height: calc(100% - 280px);
	}

	.count-text {
		color: #606266;
		font-weight: 400;
		margin-left: 8px;
	}

	.empty-guide {
		padding: 80px 20px;
		text-align: center;
	}

	.state-1 {
		color: #67C23A;
	}
	.state-0 {
		color: #909399;
	}
</style>



// WEBPACK FOOTER //
// src/components/buyer/warehouse/promotion.vue